import { useEffect, useReducer } from 'react';
import { useProject } from 'store/project';
import {
  InspectionEvolutionFilters,
  InspectionChart,
} from 'shared/types/analytics';
import { extractFiltersValues } from 'charts/common/filterValues';
import { useInspectionChartDependencies } from 'charts/common/useInspectionChartDependencies';
import { isEmptyArray } from 'shared/utils/array';
import { createInspectionEvolutionReducer } from './filtersReducer';
import { useChartFiltersPersistence } from 'charts/common/useChartFiltersPersistence';
import { defaultValues } from './defaultFilters';
import { createFiltersForView } from './createFilters';
import { useFiltersActions } from 'charts/common/filtersActions';

export function useInspectionEvolutionFilters():
  | InspectionEvolutionFilters
  | undefined {
  const { timezone } = useProject();


  const [filters, dispatchFilters] = useReducer(
    createInspectionEvolutionReducer(timezone),
    undefined
  );
  const { rewriteFilters, ...filtersActions } =
    useFiltersActions(dispatchFilters);

  const { savedFilters } = useChartFiltersPersistence(InspectionChart.inspectionEvolution, filters, defaultValues);

  const dependencies = useInspectionChartDependencies(savedFilters);

  useEffect(() => {
    if (!dependencies || isEmptyArray(dependencies.processes)) return;

    const filterValues = extractFiltersValues(filters) ?? dependencies.filters;
    rewriteFilters(createFiltersForView({ ...dependencies, filters: filterValues }, filtersActions));
  }, [dependencies, rewriteFilters]);

  return filters;
}
